import DefaultCatalogConfig, { CatalogConfigProps } from './DefaultCatalogConfig';

export default class ShopsCatalogConfig extends DefaultCatalogConfig {
  constructor(props: CatalogConfigProps) {
    super(props);

    this.newCategory = props.isGlobalMarket && props.isEditorForCurrentMarket;

    this.category.import = props.isEditorForCurrentMarket;
    this.category.redirectIdRequired = false;
    this.category.publishMinDaysDelay = 0;

    this.allowHoverActions = props.isEditorForCurrentMarket;
    this.allowRanking = props.isEditorForCurrentMarket;
    this.item.copy = false;
    this.item.remove = props.isEditorForCurrentMarket;
    this.item.cut = false;
  }
}
